module.exports = __webpack_public_path__ + "static/media/avatar_atul_ohri.8206608d.jpg";